export default __webpack_public_path__ + "static/media/project-management.ecb7dd03.svg";